import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faImages } from '@fortawesome/free-solid-svg-icons';
import { BrowserView, MobileView } from 'react-device-detect';
import { Container, Row, Col } from 'reactstrap';
import Lightbox from 'lightbox-react';
import { uniqueId } from 'lodash';
import { useImage } from '../../services/Image/useImage';
import CarUploadButtons from './CarUploadButtons';
import Translate from '../common/Translate';
import 'lightbox-react/style.css';

const CarPhotoSlider = (props) => {
  const { formId, sectionId, questionId, questionType, selectedZone, resetState, zone } = props;

  let pathImage0 = '';
  let pathImage1 = '';
  let questionImageId = questionId;
  let questionImageType = questionType;
  if (selectedZone === undefined) {
    pathImage0 = `inspection.children.${sectionId}.children.${questionId}.images.0.id`;
    pathImage1 = `inspection.children.${sectionId}.children.${questionId}.images.1.id`;
  } else {
    pathImage0 = `inspection.children.${sectionId}.children.${questionId}.children.${selectedZone}.images.0.id`;
    pathImage1 = `inspection.children.${sectionId}.children.${questionId}.children.${selectedZone}.images.1.id`;
    questionImageId = selectedZone;
    questionImageType = zone.type;
  }

  const [image0, setImage0] = useImage(formId, pathImage0, questionImageId, questionImageType);
  const [image1, setImage1, deleteImage1] = useImage(formId, pathImage1, questionImageId, questionImageType);
  const scroller = React.createRef();
  const images = [image0, image1];
  const setImages = [setImage0, setImage1];
  const [popedUp, setPopup] = useState(false);
  const [index, setIndex] = useState(0);
  const handleAddImage = (e, i) => {
    setImages[i](e.target.files[0]).then(() => resetState('image'));
  };

  const deleteImage = (key) => {
    if (key === 0) setImage0(image1);
    deleteImage1();
    resetState();
  };

  const togglePopup = () => {
    setPopup(!popedUp);
  };

  // this.scroller = React.createRef();

  // componentDidUpdate() {
  //   const scroller = document.getElementById("scroller");
  //   if (scroller) {
  //     scroller.scrollLeft = 0;
  //     let scrollAmount = 0;
  //     var slideTimer = setInterval(function() {
  //       scrollAmount += 10;
  //       scroller.scrollLeft += scrollAmount;
  //       if (scrollAmount >= scroller.offsetWidth / 2) {
  //         window.clearInterval(slideTimer);
  //       }
  //     }, 25);
  //   }
  // }

  if (!images[0]) {
    return (
      <CarUploadButtons
        formId={formId}
        sectionId={sectionId}
        questionId={questionId}
        setImage={(event) => handleAddImage(event, 0)}
      />
    );
  }
  if (!images[1]) {
    return (
      <>
        <div className="single-image">
          {popedUp && <Lightbox mainSrc={images[0]} onCloseRequest={togglePopup} />}
          <MobileView>
            <div className="slide-wrapper">
              <div className="image-wrapper">
                <img
                  src={images[0]}
                  alt=""
                  onClick={() => togglePopup(images[0])}
                  onKeyDown={() => {}}
                  role="presentation"
                />
              </div>
              <label htmlFor={`redo_${questionId}_${selectedZone}`}>
                <div className="btn btn-link">
                  <Translate code="redo" />
                </div>
                <input
                  id={`redo_${questionId}_${selectedZone}`}
                  className="d-none"
                  type="file"
                  accept="image/*"
                  onChange={(event) => handleAddImage(event, 0)}
                />
              </label>
            </div>

            <label htmlFor={`upload_camera_${questionId}_${selectedZone}`} className="button-camera circle">
              <FontAwesomeIcon icon={faCamera} />
              <input
                type="file"
                id={`upload_camera_${questionId}_${selectedZone}`}
                accept="image/*"
                capture="camera"
                onChange={(event) => handleAddImage(event, 1)}
              />
            </label>
          </MobileView>
          <BrowserView>
            <Container>
              <Row>
                <Col xs="6">
                  <div className="slide-wrapper">
                    <div className="image-wrapper">
                      <img
                        src={images[0]}
                        alt=""
                        onClick={() => togglePopup(images[0])}
                        onKeyDown={() => {}}
                        role="presentation"
                      />
                    </div>
                    <label htmlFor={`redo_${questionId}_${selectedZone}`}>
                      <div className="btn btn-link">
                        <Translate code="redo" />
                      </div>
                      <input
                        id={`redo_${questionId}_${selectedZone}`}
                        className="d-none"
                        type="file"
                        accept="image/*"
                        capture="camera"
                        onChange={(event) => handleAddImage(event, 0)}
                      />
                    </label>
                  </div>
                </Col>
                <Col xs="6">
                  <label htmlFor={`upload_camera_${questionId}_${selectedZone}`} className="button-camera circle">
                    <FontAwesomeIcon icon={faImages} />
                    <input
                      type="file"
                      id={`upload_camera_${questionId}_${selectedZone}`}
                      accept="image/*"
                      capture="camera"
                      onChange={(event) => handleAddImage(event, 1)}
                    />
                  </label>
                  <div className="text-center">
                    <Translate code="photo_gallery" />
                  </div>
                </Col>
              </Row>
            </Container>
          </BrowserView>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="multiple-image">
        {popedUp && (
          <Lightbox
            mainSrc={images[index]}
            nextSrc={images[(index + 1) % images.length]}
            prevSrc={images[(index + images.length - 1) % images.length]}
            onCloseRequest={togglePopup}
            onMovePrevRequest={() => setIndex((index + images.length - 1) % images.length)}
            onMoveNextRequest={() => setIndex((index + 1) % images.length)}
          />
        )}
        <MobileView>
          <div className="multiple-image-wrapper" ref={scroller} id="scroller">
            {images.map((base64, key) => (
              <React.Fragment key={uniqueId(key)}>
                <div className="slide-wrapper">
                  <div className="image-wrapper">
                    <img
                      src={base64}
                      alt=""
                      onClick={() => togglePopup(key)}
                      onKeyDown={() => {}}
                      role="presentation"
                    />
                  </div>
                  <button type="button" className="btn btn-link" onClick={() => deleteImage(key)}>
                    <Translate code="delete" />
                  </button>
                </div>
              </React.Fragment>
            ))}
          </div>
        </MobileView>

        <BrowserView>
          <Container>
            <Row>
              {images.map((base64, key) => (
                <React.Fragment key={uniqueId(key)}>
                  <Col xs="6">
                    <div className="slide-wrapper">
                      <div className="image-wrapper">
                        <img
                          src={base64}
                          alt=""
                          onClick={() => togglePopup(key)}
                          onKeyDown={() => {}}
                          role="presentation"
                        />
                      </div>
                      <button type="button" className="btn btn-link w-100" onClick={() => deleteImage(key)}>
                        <Translate code="delete" />
                      </button>
                    </div>
                  </Col>
                </React.Fragment>
              ))}
            </Row>
          </Container>
        </BrowserView>
      </div>
    </>
  );
};

export default CarPhotoSlider;

CarPhotoSlider.propTypes = {
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  questionType: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  selectedZone: PropTypes.string.isRequired,
  resetState: PropTypes.func.isRequired,
  zone: PropTypes.shape().isRequired,
};
